import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class LoadingService {
  public load$ = new BehaviorSubject<object>({
    active: false,
    text: "",
  });

  loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loadingMap: Map<string, boolean> = new Map<string, boolean>();

  constructor() {}

  setLoadState(data: object) {
    this.load$.next(data);
  }

  setLoading(loading: boolean, url: string): void {
    const _url = url.replace(/:/gi, "");
    if (!url) {
      throw new Error(
        "O URL da solicitação deve ser fornecido para a função LoadingService.setLoading"
      );
    }
    this.loading$.next(loading);
  }
}
